export class HotSupportChatStatus {
  type: string;
  is_online: boolean;
}
